import {
  GenerateQueriesArgs,
  generateActionQueries,
  generateQueries,
} from 'src/queries/queryGenerator'
import {
  SellerTenderResponseProduct,
  SellerTenderResponseProductPayload,
} from 'src/types/sellerTenderResponse'

export const SELLER_TENDER_RESPONSE_PRODUCTS_ENDPOINT = 'seller/tender_response_products'
export const SELLER_TENDER_RESPONSE_PRODUCTS_QUERY_KEY = 'sellerTenderResponseProducts'
export const SELLER_TENDER_INVITATIONS_ENDPOINT = 'seller/tender_invitations'

export interface SellerTenderResponseProductsQueryParams {
  limit?: number
  offset?: number
}

const generateQueriesConfig: GenerateQueriesArgs<
  SellerTenderResponseProduct,
  SellerTenderResponseProductsQueryParams,
  SellerTenderResponseProductPayload
> = {
  endpoint: SELLER_TENDER_RESPONSE_PRODUCTS_ENDPOINT,
  queryKey: SELLER_TENDER_RESPONSE_PRODUCTS_QUERY_KEY,
}

export const {
  useSingleEntityQuery: useSellerTenderResponseProductQuery,
  usePostEntity: usePostSellerTenderResponseProductMutation,
  usePutEntity: usePutSellerTenderResponseProductMutation,
} = generateQueries(generateQueriesConfig)

export interface DeclineTenderPayload {
  id: Id
  declinedReason: string
}

export interface DeclineTenderResponse {
  id: Id
}

export const { useDeclineAction: useDeclineTenderAction } = generateActionQueries<
  'decline',
  DeclineTenderPayload,
  {},
  DeclineTenderResponse
>({
  endpoint: SELLER_TENDER_INVITATIONS_ENDPOINT,
  actions: ['decline'],
})
